module.exports = __webpack_public_path__ + "05_face.8878d0ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/05_face.png
// module id = 3p1B
// module chunks = 0